
import { PropOptions } from 'vue'
import { UiImage, UiTitle } from '~/components/atoms'
import { SectionBlogLead } from '~/apis/clients/graphql/types/contentful'
import RichTextRenderer from '~/components/renderers/rich-text-renderer/index.vue'

export default {
  components: {
    UiImage,
    UiTitle,
    RichTextRenderer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    leadSection: {
      type: Object,
      required: true,
    } as PropOptions<SectionBlogLead>,
  },
  computed: {
    dynamicMargin() {
      const minimalMargin = 'calc(15rem * 0.8)'
      if (!this.leadSection?.image?.file?.details?.image) return minimalMargin
      const { ratio } = this.leadSection.image.file.details.image
      const dynamicMargin = ratio ? (0.8 / ratio) * 100 : 10000
      return `min(${dynamicMargin}%, ${minimalMargin})`
    },
  },
}
